export const INTER_GATEWAY_PATH = process.env.INTER_GATEWAY_PATH
export const INTER_GATEWAY_WEB_PATH = process.env.INTER_GATEWAY_WEB_PATH
export const INTER_GATEWAY_WEB_PATH_V2 = process.env.INTER_GATEWAY_WEB_PATH_V2

export const CONTACT_FORM_POST_V3 = `${INTER_GATEWAY_WEB_PATH}/api/v1/dataextensions`
export const CONTACT_FORM_POST_V4 = `${INTER_GATEWAY_WEB_PATH_V2}/institucional/contato/v2/canais/lp-inter-asset`
